import { Button, Intent, Popover, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import carouselIcon from "../../../../assets/img/carousel.svg"
import __icon from "../../../../assets/img/angle-down.svg"
import makeupIcon from "../../../../assets/img/makeup.svg"
import SectionTypeChanger from "../../useful/SectionTypeChanger"

/* Protopia Ecosystem component */
export interface ISectionGalleryEditFormProps {
   section: ILandingSection
}
const SectionGalleryEditForm = (props: ISectionGalleryEditFormProps): JSX.Element => {
    const onMakeup = () => {
        useLandingStore.setState({ 
            isMakeupDrawerOpen: true,
            makeupType: SELECT_TYPE.GALLERY
        })
    } 

    const onEdit = () => {
        useLandingStore.setState({ 
            curEditModal: { 
                sectionId: props.section?.id, 
                currentEditType: SELECT_TYPE.SECTION, 
            },
            sectionEditTab: "layout"
        })
    }
    return <div className='landing-data-edit-form-cont '>
        <div className="landing-data-content-container  text-light small">
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Edit gallery")}
            >
                <Button 
                    intent={Intent.NONE}  
                    className={`p-1`} 
                    onClick={ onEdit }
                > 
                    <img
                        src={ carouselIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    /> 
                </Button> 
            </Tooltip>  
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Change section design type")}
            >
                <Popover 
                    position="bottom"
                    content={ <SectionTypeChanger section={props.section} /> }
                >
                    <Button 
                        intent={Intent.NONE}  
                        className={`p-1`} 
                        //onClick={ onEdit }
                    > 
                        <img
                            src={ __icon }
                            height={ 12 }
                            className="svg-force-contrast landing-icon my-2"
                            style={{
                                height: 12,
                                opacity: 1,
                            }}
                            alt=""
                        /> 
                    </Button> 
                </Popover> 
            </Tooltip>  
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Makeup")}
            >
                <Button  
                    className={` p-1`}
                    intent={Intent.WARNING}
                    onClick={ onMakeup }
                > 
                    <img
                        src={ makeupIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    />
                </Button> 
            </Tooltip>  
        </div>
    </div>
}
export default SectionGalleryEditForm